export default __webpack_public_path__ + "static/media/DeleteIcon.5ad9f015.svg";